import type { FunctionComponent } from "react";

import { ClientSideSuspense } from "shared/components/common/client-side-suspense";

import { useMyDailyFive } from "./hooks";
import { MyDailyFiveArticles } from "./my-daily-five-articles";
import { Container, Description, Title, TitleWrapper, Wrapper } from "./styles";
export type Props = {
  className?: string;
};

export const MyDailyFive: FunctionComponent<Props> = ({ className }) => {
  const { status } = useMyDailyFive();

  return (
    <Container className={className}>
      <Wrapper $isLoading={status !== "success"}>
        <TitleWrapper>
          <Title>My Daily 5</Title>
          <Description>Five daily stories, curated for you</Description>
        </TitleWrapper>

        <ClientSideSuspense>
          <MyDailyFiveArticles />
        </ClientSideSuspense>
      </Wrapper>
    </Container>
  );
};

MyDailyFive.displayName = "MyDailyFive";
